module.exports = __webpack_public_path__ + "tile-2-image-1n3vRd9.webp";